<template>
  <div class="mb-5">
    <h1 class="mt-4">Discover {{ tab === 'profiles'?'Profiles':'Lists' }}</h1>
    <div class="d-flex justify-content-center mb-5">
      <ul class="nav nav-tabs nav-tabs-primary text-center" role="tablist">
        <li class="nav-item">
          <a class="nav-link" :class="{'active show': tab === 'lists'}" @click.prevent="tab = 'lists'" data-toggle="tab" href="#" role="tablist">
            <i class="tim-icons icon-spaceship"></i> Lists
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{'active show': tab === 'profiles'}" @click.prevent="tab = 'profiles'" data-toggle="tab" href="#" role="tablist">
            <i class="tim-icons icon-bag-16"></i> Profiles
          </a>
        </li>
      </ul>
    </div>
    <div v-if="tab === 'profiles'" class="profiles">
      <div class="row mb-5">
        <div class="col-md-8"></div>
        <div class="col-md-4">
          <div class="input-group mr-2 my-0">
            <div class="input-group-prepend">
              <div class="input-group-text p-1">
                <i class="ion ion-md-search"></i>
              </div>
            </div>
            <input type="text" placeholder="Search Profiles" class="form-control p-1 h-100" v-model="profile_search">
          </div>
        </div>
      </div>
      <div class="card mb-2" v-for="user in users" :key="user.username">
        <div class="card-header d-flex justify-content-between">
          <span></span>
          <router-link class="profile-name" :to="{ name: 'profile', params: {username: user.username}}">{{ user.username }}</router-link>
          <span class="text-muted">{{ user.num_lists }} list{{ user.num_lists | pluralize }}</span>
        </div>
      </div>
    </div>

    <list-list :lists="lists" v-if="tab === 'lists'"></list-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import constants from '@/constants'
import ListList from '@/components/ListList'

export default {
  name: 'Discover',
  components: {
    ListList,
  },
  data: function () {
    return {
      tab: 'lists',
      constants: constants,
      profile_search: ''
    }
  },
  created () {
    this.$store.dispatch('users/getUsers')
    this.$store.dispatch('lists/getLists')
  },
  computed: {
    users () {
      let users = this.$store.state.users.users
      if (this.profile_search.length > 2) {
        users = users.filter(i => i.username.toLowerCase().includes(this.profile_search.toLowerCase()))
      }
      return users
    },
    ...mapState({
      lists: state => state.lists.lists,
    })
  }
}
</script>

<style lang="scss" scoped>
.profiles {
  .card {
    .card-header {
      padding: 15px;
      .profile-name {
        font-size: 20px;
      }
    }
  }
}
</style>
